import React, { useState } from "react";
import ShareIcon from "../../../assets/images/icons/icon-share.svg";
import HeartIcon from "../../../assets/images/icons/icon-heart.svg";
import HeartFilledIcon from "../../../assets/images/icons/icon-heart-filled.svg";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAppConfig, setActivityIndicator } from "../../../redux/slices/appconfigSlice";
import { getLoginConfig } from "../../../redux/slices/loginconfigSlice";
import { getSearchFilters } from "../../../redux/slices/searchFilterSlice";
import { getFlightsParams, handleFavoriteHotelItem, postPunchOutAndOpenExternal } from "../../../helpers/common";
import { getBooking } from "../../../redux/slices/bookingSlice";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import branch from "branch-sdk";
import { toast } from "react-toastify";
import { CopyToClipboard } from "react-copy-to-clipboard/src";
import PropTypes from "prop-types";
import Lottie from "lottie-react";
import MapJson from '../../../assets/images/lottieViews/map.json';
import AppConfig from "../../../helpers/config";
import useTranslationCustom from "../../../i18n/customHook/useTranslation";
import Expedia from "../../../assets/images/icons/expedia.svg";
import ExpediaDark from "../../../assets/images/icons/expedia-logo-dark.svg";
import { GetFlightDetailsService } from "../../../services/HotelDetailServices";
// import BackArrow from "../../../assets/images/arrow.svg";
import ShareBranchLink from "./ShareBranchLink";
import GeniusJson from "../../../assets/images/lottieViews/genius.json";
import BulbJson from "../../../assets/images/lottieViews/bulb.json";
import { isMobile, isTablet } from "react-device-detect";
import { buildShareLink, getFlightNumbersString } from "../../../utils/webShareLink";
import { getDetailPath, getDetailUrl, getShareLandingIdx } from "../../../utils/detailUrl";

const TopBar = ({
    isMap = false,
    flightRef = null,
    headerRef = null,
    handleMapBackClick = null,
    normalComponent = false,
    gallery = false
}) => {
    const { T } = useTranslationCustom();
    const prevUrl = localStorage.getItem('prevUrl');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const booking = useSelector(getBooking);
    const { room, flight } = booking;
    const { selectedHotel, selectedHotelToShare } = useSelector(getSearchFilters);
    const appconfig = useSelector(getAppConfig);
    const loginconfig = useSelector(getLoginConfig);
    const searchfilters = useSelector(getSearchFilters);
    const [shortLink, setShortLink] = useState("");

    // The canonical detail URL, not window.location: the address bar is swapped
    // for the share URL once the package details API resolves.
    const url = getDetailUrl();
    const isFav = (typeof window !== 'undefined' ? new URL(url).searchParams.get("fav") : null) === 'true';
    const isChatOffer = new URL(url).searchParams.get("chatOffer") === 'true';
    const flightNumbersStringFromUrl = new URL(url).searchParams.get("flightNumbersString");

    const createLink = () => {
        // Package sharing uses a Branch short link: it opens the package in the
        // mobile app when installed and falls back to this web app otherwise.
        // Fallback to the current origin so each environment's links land on the
        // web app that created them (same Branch key on both ends). Branch only
        // accepts redirect URLs on allowlisted domains and rejects the link (400)
        // otherwise, so other origins (localhost, previews) use the environment's
        // public domain.
        const isAllowlistedOrigin = /(^|\.)genius\.travel$/.test(window.location.hostname);
        const getURL = isAllowlistedOrigin
            ? `${window.location.origin}/`
            : AppConfig.baseApiURL.includes('staging')
                ? 'https://staging.genius.travel/'
                : 'https://genius.travel/';

        // The shared package is the offer the user opened, but they may since have
        // switched room or flight. Put the selected ones in the slots every receiver
        // reads (web FavoriteAccordion, mobile HotelFilters): roomTypes[0] for the
        // room/travellers and objHotel.newPackagedOffer.flightOffer for the flight.
        // Same shape the mobile app shares (helpers/branchio.js).
        const flightOffer = flight || selectedHotelToShare?.objHotel?.newPackagedOffer?.flightOffer;
        const payload = {
            ...selectedHotelToShare,
            roomTypes: room ? [room] : selectedHotelToShare?.roomTypes,
            objHotel: {
                ...selectedHotelToShare?.objHotel,
                newPackagedOffer: {
                    ...selectedHotelToShare?.objHotel?.newPackagedOffer,
                    flightOffer,
                },
            },
            flightNumbersString: getFlightNumbersString(flightOffer) || null,
        };

        const linkData = {
            campaign: 'genius/package',
            data: {
                payload: JSON.stringify(payload),
                '$ios_url': getURL,
                '$ios_url_xx': getURL,

                '$android_url': getURL,
                '$android_url_xx': getURL,

                '$fallback_url': getURL,

                '$og_title': selectedHotelToShare?.name,
                '$og_description': `★ ${selectedHotelToShare?.starRating} • ${selectedHotelToShare?.address}`,
                '$og_image_url': selectedHotelToShare?.thumbnailUrl
            }
        };

        // Branch can be unreachable (e.g. blocked by an ad blocker); keep sharing
        // working with the web link instead of leaving the menu empty.
        const setLinkOrFallback = (err, link) => {
            setShortLink(!err && link ? link : buildShareLink(selectedHotelToShare, flight));
        };

        branch.link(linkData, function (err, link) {
            if (!err && link) {
                setShortLink(link);
                return;
            }
            // Only Home initialises Branch, so a detail page opened directly (new
            // tab, refresh) gets "not initialized". Initialise once and retry.
            branch.init(AppConfig.branchKey, function (initErr) {
                if (initErr) {
                    setLinkOrFallback(initErr);
                    return;
                }
                branch.link(linkData, setLinkOrFallback);
            });
        });
    }

    const handleOnBooking = () => {
        const params = getFlightsParams(
            room,
            searchfilters,
            loginconfig,
            booking,
            appconfig,
            searchfilters?.selectedHotel?.id,
            searchfilters?.selectedHotel?.guidForBooking,
            isFav,
            isChatOffer
        );
        const BaseUrl = window.location.origin;
        const newTab = window.open(`${BaseUrl}/fetching`, '_blank');

        try {
            params.GetFinalExpediaUrl = true;
            params.transaction_id = appconfig?.transaction_id;

            // console.log(JSON.stringify(params), "params for getting more flights");

            dispatch(setActivityIndicator(true));
            GetFlightDetailsService(params)
                .then((_flightDetails) => {
                    dispatch(setActivityIndicator(false));

                    // console.log({_flightDetails});

                    if (
                        _flightDetails?.warnings?.length &&
                        _flightDetails?.warnings[0]?.code === "400.19"
                    ) {
                        toast.info(_flightDetails?.warnings[0]?.description);
                        return;
                    }

                    const externalUrl = _flightDetails?.offers[0]?.links?.webDetails?.href;
                    postPunchOutAndOpenExternal({
                        url: externalUrl,
                        transactionId: appconfig?.transaction_id,
                        guid: searchfilters?.selectedHotel?.guidForBooking,
                        dispatch,
                        setActivityIndicator,
                        existingTab: newTab,
                    });
                })
                .catch(() => {
                    dispatch(setActivityIndicator(false));
                    if (newTab) {
                        newTab.close();
                    }
                });
        } catch (e) {
            if (newTab) {
                newTab.close();
            }
        }
    };

    const splitString = (input) => {
        const regex = /\b(or|of)\b/i; // Matches "or" or "of" as whole words, case-insensitively
        const match = input.match(regex);
        if (match) {
            const index = match.index;
            // const word = match[0];
            // Split the string into two parts: before and after the matched word (inclusive)
            const before = input.slice(0, index).trim();
            const after = input.slice(index).trim();
            return [before, after]; // Keep the word and the text after it together
        }
        // Return the input as a single element if no match
        return [input];
    }

    function handleClick(index) {
        if (index === 0) {
            handleOnBooking();
        } else {
            flightRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    const shouldReplace = () => {
        if (appconfig?.branchData) {
            return false;
        } else if (isFav) {
            return true;
        } else {
            return true;
        }
    }

    // React Router stamps an incrementing `idx` on every history entry it pushes.
    // idx 0 (or a missing state, e.g. a direct load) means there is nothing to pop
    // back to, so navigate(-1) would be a no-op.
    const canGoBack = () => {
        if (typeof window === 'undefined') {
            return false;
        }
        const idx = window.history.state?.idx;
        if (typeof idx !== 'number') {
            return window.history.length > 1;
        }
        if (idx <= 0) {
            return false;
        }
        // The entry behind us can be the share link this session was opened with.
        // Popping onto it lands on /link, which renders this same detail page once
        // a detail session exists — and the address bar already shows that URL, so
        // the click would look like it did nothing.
        const landingIdx = getShareLandingIdx();
        return landingIdx === null || idx - 1 > landingIdx;
    }

    const goBack = () => {
        if (canGoBack()) {
            navigate(-1);
        } else {
            navigate('/', { replace: true });
        }
    }

    const getType = () => {
        if (appconfig?.branchData) {
            return 'branch';
        } else if (isFav) {
            return 'fav';
        } else if (isChatOffer) {
            return 'chatOffer';
        } else {
            return 'normal';
        }
    }

    return (
        <div id="topBar" className="topbar-wrapper" ref={headerRef}>
            <div className="container">
                <div className={isMap ? '' : 'content-holder'}>
                    <div className="left-action" onClick={() => {
                        if (normalComponent && gallery) {
                            // Back to the readable detail URL captured before the
                            // address bar was swapped for the share URL. Popping
                            // history instead would land on the share URL, which
                            // rebuilds the package from scratch via Home.
                            navigate(getDetailPath(), { replace: true });
                            return;
                        }
                        if (normalComponent) {
                            goBack();
                            return;
                        }
                        if (isMap && handleMapBackClick) {
                            handleMapBackClick();
                            return;
                        }
                        // prevUrl is the share link itself when this session was
                        // opened from one, which would just re-render this page.
                        if (prevUrl && !prevUrl.startsWith('/link')) {
                            navigate(prevUrl, { replace: true });
                        } else {
                            navigate('/', { replace: true });
                        }
                    }}>
                        {!isMap && isChatOffer && !gallery ? (
                            <div className="">
                                <a className="animated-back-btn">
                                    <Lottie animationData={GeniusJson} loop={true} className='genius-animation' />
                                    <Lottie animationData={BulbJson} loop={true} className='bulb-animation' />
                                    <span>{T("Buttons:Button_Chat_Ai")}</span>
                                </a>
                            </div>
                        ) : <a>{T("Buttons:Back")}</a>}
                    </div>

                    {!isMap && <div className={'expedia-section'}>
                        {!gallery && (<div>
                            <p onClick={(e) => {
                                e.preventDefault();
                                handleClick(0)
                            }}>
                                {splitString(T('Packages_Detail:Top_Bar_Direct_Expedia'))[0]}
                            </p>
                            <p onClick={(e) => {
                                e.preventDefault();
                                handleClick(1)
                            }}>
                                {splitString(T('Packages_Detail:Top_Bar_Direct_Expedia'))[1]}
                            </p>
                        </div>)}
                        <img
                            src={loginconfig.darkMode ? Expedia : ExpediaDark}
                            alt={"expedia"}
                        />
                    </div>}

                    {!isMap && <div className="right-action">
                        <ul>
                            {!gallery && (
                                <li>
                                    <a
                                        rel="noopener noreferrer"
                                        className="show-map-link"
                                        onClick={() => {
                                            // Verification log: per-person price on the detail screen.
                                            console.log(
                                                'DETAILS pricePerPerson',
                                                flight?.price?.averageCostPerPerson?.value,
                                                { hotelId: selectedHotel?.id }
                                            );
                                            // Pass the selected flight (state.booking.flight) + its hotelId
                                            // through router state so the map can restore the exact flight/
                                            // price — the booking slice is reset when this page unmounts.
                                            navigate(`/hotel/${selectedHotel?.id}/map/${getType()}`, {
                                                replace: shouldReplace(),
                                                state: { isChatOffer, flight, flightHotelId: selectedHotel?.id, flightNumbersStringFromUrl },
                                            });
                                        }}
                                    >
                                        <Lottie animationData={MapJson} loop={true} className='map_animation' />
                                        <span>{T("Packages_Detail:Show_On_Map")}</span>
                                    </a>
                                </li>)}
                            {!gallery && (
                                <li>
                                    <Dropdown className="share-button" onToggle={createLink}>
                                        <Dropdown.Toggle>
                                            <img src={ShareIcon} alt={"share-icon"} />
                                            {!(isMobile || isTablet) && T("Buttons:Share")}
                                        </Dropdown.Toggle>
                                        {shortLink &&
                                            <Dropdown.Menu>
                                                <h6>{T("Packages_Detail:Copy_To_Clipboard")}</h6>
                                                <div className="d-flex">
                                                    <input
                                                        readOnly={true}
                                                        type="text"
                                                        id="urlField"
                                                        value={shortLink}
                                                    ></input>
                                                    <CopyToClipboard
                                                        text={`${T('Packages_Detail:Text_With_Shared_Link')}\n\n${shortLink}\nGenius`}
                                                        onCopy={() => {
                                                            toast.success(`${T("Packages_Detail:Link_Copied")}`);
                                                        }}>
                                                        <button id="copyButton">
                                                            <FontAwesomeIcon icon={faCopy} />
                                                        </button>
                                                    </CopyToClipboard>
                                                </div>
                                                <div>
                                                    <ShareBranchLink shortLink={shortLink} />
                                                </div>
                                            </Dropdown.Menu>
                                        }
                                    </Dropdown>
                                </li>)}
                            <li>
                                <a
                                    onClick={() =>
                                        handleFavoriteHotelItem(
                                            loginconfig,
                                            dispatch,
                                            searchfilters,
                                            searchfilters?.selectedHotel,
                                            appconfig,
                                            null,
                                            null,
                                            booking?.flight
                                        )
                                    }
                                >
                                    <img
                                        src={
                                            selectedHotel?.favoriteGuid ? HeartFilledIcon : HeartIcon
                                        }
                                        alt={"heart-icon"}
                                    />
                                    {selectedHotel?.favoriteGuid
                                        ? T("Buttons:Saved")
                                        : T("Buttons:Save")}
                                </a>
                            </li>
                        </ul>
                    </div>}
                </div>
            </div>
        </div>
    );
};

TopBar.propTypes = {
    isMap: PropTypes.bool,
    normalComponent: PropTypes.bool,
    flightRef: PropTypes.any,
    headerRef: PropTypes.any,
    handleMapBackClick: PropTypes.func,
    gallery: PropTypes.bool
}

export default TopBar;
